import React, { useState } from "react";
import { MdLocationOn } from "react-icons/md";
import "./events_gallery.css";

import EventNavigation from "../EventNavigation/EventNavigation";
import Footer from "../Footer/Footer";
import { pastEvents, sortEventsNewestFirst } from "./galleryEvents";

const EventSection = ({ event, onImageClick }) => (
  <article className="events_gallery_event">
    <div className="events_gallery_event_details">
      <p className="events_gallery_event_meta">{event.date}</p>
      <h2 className="events_gallery_event_title">{event.title}</h2>
      <p className="events_gallery_event_location">
        <MdLocationOn aria-hidden="true" />
        <span>{event.location}</span>
      </p>
      <p className="events_gallery_event_desc">{event.description}</p>
      {/* <div className="events_gallery_event_tags">
        {event.details.map((detail) => (
          <span key={detail}>{detail}</span>
        ))}
      </div> */}
      {event.ctaUrl && (
        <a className="events_gallery_event_cta" href={event.ctaUrl} target="_blank" rel="noopener noreferrer">
          {event.ctaLabel}
        </a>
      )}
    </div>

    {(event.images || []).length > 0 && (
      <div className="events_gallery_image_scroller" aria-label={`${event.title} photos`}>
        {event.images.map((image, index) => (
          <button
            className="events_gallery_image_btn"
            key={`${event.id}-${index}`}
            type="button"
            onClick={() => onImageClick({ src: image, alt: `${event.title} photo ${index + 1}` })}
            aria-label={`Open ${event.title} photo ${index + 1}`}
          >
            <img src={image} alt={`${event.title} ${index + 1}`} loading="lazy" />
          </button>
        ))}
      </div>
    )}
  </article>
);

const EventsGallery = () => {
  const [activeImage, setActiveImage] = useState(null);
  const visibleEvents = sortEventsNewestFirst(pastEvents);

  return (
    <>
      <EventNavigation />

      <section id="events_gallery_intro">
        <div id="events_gallery_intro_inner">
          <p id="events_gallery_intro_eyebrow">PropTech Club Gallery</p>
          <h1 id="events_gallery_intro_hdng">Where real estate leaders meet what comes next.</h1>
          <p id="events_gallery_intro_txt">
            Browse the key moments from the PropTech Club ecosystem.
          </p>
        </div>
      </section>

      <main id="club_gallery_section">
        <section className="events_gallery_list" aria-live="polite">
          {visibleEvents.map((event) => (
            <EventSection event={event} key={event.id} onImageClick={setActiveImage} />
          ))}
        </section>
      </main>

      {activeImage && (
        <div className="events_gallery_lightbox" role="dialog" aria-modal="true" aria-label="Enlarged event photo">
          <button className="events_gallery_lightbox_backdrop" type="button" onClick={() => setActiveImage(null)} aria-label="Close image" />
          <div className="events_gallery_lightbox_content">
            <button className="events_gallery_lightbox_close" type="button" onClick={() => setActiveImage(null)}>
              Close
            </button>
            <img src={activeImage.src} alt={activeImage.alt} />
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default EventsGallery;
